export function round(value) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (Math.abs(base) >= 1) {
    return Math.round(value / base) * base;
  } else {
    // Sometimes when a number is multiplied by a small number, precision is lost,
    // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
    var counterBase = 1 / base;
    return Math.round(value * counterBase) / counterBase;
  }
}
/**
 * Be careful, NaN can return
 */
export function toInt(value) {
  return parseInt(value);
}
/**
 * Be careful, NaN can return
 */
export function toFloat(value) {
  return parseFloat(value);
}
export function replaceNaN(value, replacement) {
  return typeof value === 'number' && isNaN(value) ? replacement : value;
}

/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */

/**
 * Does the same as Array.prototype.includes but has better typing
 */
export function includes(haystack, needle) {
  for (var i = 0, l = haystack.length; i < l; ++i) {
    if (haystack[i] === needle) {
      return true;
    }
  }
  return false;
}

/**
 * Like `!includes()` but with proper typing
 */
export function excludes(haystack, needle) {
  return !includes(haystack, needle);
}

/**
 * Converts a string to UTF8 bytes
 */
export function getUTF8Bytes(input) {
  // Benchmark: https://jsbench.me/b6klaaxgwq/1
  // If you want to just count bytes, see solutions at https://jsbench.me/ehklab415e/1
  var result = new Uint8Array(input.length);
  for (var i = 0; i < input.length; i++) {
    // `charCode` is faster than encoding, so we prefer that when it's possible
    var charCode = input.charCodeAt(i);

    // In case of non-ASCII symbols we use proper encoding
    if (charCode > 127) {
      return new TextEncoder().encode(input);
    }
    result[i] = charCode;
  }
  return result;
}